import React from 'react';
import './About.css';
import Carousel from '../components/Carousel';

const About = () => {
  return (
    <>
      {/* 公司简介 */}
      <section className="company-intro-section section">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="company-img">
                <img src="/images/company-gate.jpg" alt="巨隆液压集团大门" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="company-text">
                <h3>公司简介</h3>
                <p>巨隆液压设备（集团）有限公司成立于1983年，前身为温州巨隆液压有限公司，是国内较早生产煤矿成套综采液压支架设备、立柱、阀类等配件产品的厂家之一，是国内第一批荣获国家原煤炭工业部定点生产单位。</p>
                <p>公司主要从事矿用成套综采液压支架，液压支架的立柱、千斤顶、控制操纵阀等配件的研究，开发与制造。公司荣获中国煤炭机械工业协会优秀企业、中国煤炭机械工业协会常务理事单位，安徽省民营科技企业，高新技术企业，安徽省著名商标。</p>
                <p>公司坐落在安徽新芜经济开发区，占地面积400亩，分为4个生产厂区，工业厂房建筑面积8万平方米，年产值达到4亿多元。现拥有钢材加热、大型模锻压、热处理、机械加工中心、数控机床、自动焊接等各类设备400多台套，2条镀铬、锌生产线。</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 公司厂区 */}
      <section className="company-factory-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">公司厂区</h2>
            <div className="section-line"></div>
          </div>
          <Carousel />
        </div>
      </section>

      {/* 荣誉资质 */}
      <section className="honors-section section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">荣誉资质</h2>
            <div className="section-line"></div>
          </div>
          <div className="honors-grid">
            <div className="honor-card">
              <div className="honor-img">
                <img src="/images/ry-1.jpg" alt="荣誉资质" />
              </div>
            </div>
            <div className="honor-card">
              <div className="honor-img">
                <img src="/images/ry-2.jpg" alt="荣誉资质" />
              </div>
            </div>
            <div className="honor-card">
              <div className="honor-img">
                <img src="/images/ry-3.jpg" alt="荣誉资质" />
              </div>
            </div>
            <div className="honor-card">
              <div className="honor-img">
                <img src="/images/ry-4.jpg" alt="荣誉资质" />
              </div>
            </div>
            <div className="honor-card">
              <div className="honor-img">
                <img src="/images/ry-5.jpg" alt="荣誉资质" />
              </div>
            </div>
            <div className="honor-card">
              <div className="honor-img">
                <img src="/images/ry-6.jpg" alt="荣誉资质" />
              </div>
            </div>
            <div className="honor-card">
              <div className="honor-img">
                <img src="/images/ry-7.jpg" alt="荣誉资质" />
              </div>
            </div>
            <div className="honor-card">
              <div className="honor-img">
                <img src="/images/ry-8.jpg" alt="荣誉资质" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
